import {HttpClient} from "../../service/httpClient/HttpClient";

export class PaymentGatewayService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getGatewaysList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `payment-gateways`,
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    addNewGateway(title, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `payment-gateways`,
                {
                    title, type
                }
            ).then(resolve).catch(reject)
        })
    }

    getGatewayInfo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `payment-gateways/${id}/information`
            ).then(resolve).catch(reject)
        })
    }

    updateGatewayInfo(id, title, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `payment-gateways/${id}`,
                {
                    title, type
                }
            ).then(resolve).catch(reject)
        })
    }

    getGatewayToken(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `payment-gateways/${id}/token`
            ).then(resolve).catch(reject)
        })
    }


    updateGatewayToken(id, token) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `payment-gateways/${id}/token`,
                {},
                {
                    token
                }
            ).then(resolve).catch(reject)
        })
    }
    testGatewayToken(id){
        return new Promise((resolve, reject)=>{
            this.httpClient.get(
                `/payment-gateways/${id}/connections/test`,
            ).then(resolve).catch(reject)
        })
    }

    getGatewayEnabled(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `payment-gateways/${id}/enabled`
            ).then(resolve).catch(reject)
        })
    }

    updateGatewayEnabled(id, enabled) {

        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `payment-gateways/${id}/enabled`,
                {},
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    getGatewayMain(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `payment-gateways/${id}/main`
            ).then(resolve).catch(reject)
        })
    }

    updateGatewayMain(id, main) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `payment-gateways/${id}/main`,
                {},
                {
                    main
                }
            ).then(resolve).catch(reject)
        })
    }

    getAvailableGateways(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `payment-gateways/selections`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }
}